import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
//import { getFunctions } from "firebase/functions";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  appId: process.env.REACT_APP_APP_ID,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

initializeApp(firebaseConfig);

const db = getFirestore();
const analytics = getAnalytics();
//const functions = getFunctions();

export  {
   db as default, 
   analytics,
   //functions as default,
}


// Initialize Firebase
//const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
//const analytics = getAnalytics(app);